import React from 'react'
import PropTypes from 'prop-types'
import DarkPrimaryButton from 'components/DarkPrimaryButton'
import EventLock from './EventLock'

const EventCardEmptyContent = ({
  tag,
  showJoinButton,
  showComingSoonButton,
  onJoinButtonClick,
}) => (
  <div className="absolute w-full h-full pl-5 pt-5 md:pl-7 md:pt-7">
    {showJoinButton && (
      <div className="absolute">
        <EventLock />
      </div>
    )}
    <div className="absolute bottom-14 text-white">
      {tag.description && (
        <>
          <div className="text-4xl font-ownersWide mb-3.5 md:text-6xl">{tag.name}</div>
          <div className="opacity-60 text-base pr-4 mb-6 md:max-w-md text-lg">
            {tag.description}
          </div>
        </>
      )}
      {showJoinButton && (
        <DarkPrimaryButton onClick={onJoinButtonClick}>Join Waitlist</DarkPrimaryButton>
      )}
      {showComingSoonButton && (
        <DarkPrimaryButton className="cursor-default">Coming soon</DarkPrimaryButton>
      )}
    </div>
  </div>
)

EventCardEmptyContent.propTypes = {
  showJoinButton: PropTypes.bool,
  showComingSoonButton: PropTypes.bool,
  onJoinButtonClick: PropTypes.func,
  tag: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }),
}

export default EventCardEmptyContent
